import React, { useContext } from 'react';

import { Typography, Button, Space } from 'antd';
import { ApplicationUIContext, Table, Drawer, useDrawerState } from '@yuhuinc/ui-library';
import { UploadOutlined, DeleteOutlined } from '@ant-design/icons';
import { CardSectionTitle } from '../../common/Styles';
import { getTranslatedString } from 'helpers/i18n';
import UploadDocument from './UploadDocument';
import { phaseTwoWip } from '../../common/actions/WipModal';
import { featureEnabled } from 'helpers/ToggleBot';

const { Link } = Typography;

const COLUMNS = [
  {
    title: getTranslatedString(
      'landlordPortal.applicationManagement.applicationOverview.review.documents.name'
    ),
    dataIndex: 'name',
    key: 'name',
    width: '60%',
    render(value) {
      return <Link href="#">{value}</Link>;
    },
  },
  {
    title: getTranslatedString(
      'landlordPortal.applicationManagement.applicationOverview.review.documents.type'
    ),
    dataIndex: 'type',
    key: 'type',
    width: '20%',
  },
  {
    title: getTranslatedString(
      'landlordPortal.applicationManagement.applicationOverview.review.documents.modifiedAt'
    ),
    dataIndex: 'modifiedAt',
    key: 'modifiedAt',
    width: '15%',
  },
  {
    key: 'actions',
    render() {
      return (
        <Button
          type="link"
          icon={<DeleteOutlined />}
          onClick={() => {
            phaseTwoWip(() => {});
          }}
        />
      );
    },
    fixed: 'right',
  },
];

const DUMMY_DATA = [
  {
    key: 1,
    name: 'drivers-licence.jpg',
    type: 'Identification',
    modifiedAt: '06-17-2022',
  },
  {
    key: 2,
    name: 'Signed application - Blanchard.jpg',
    type: 'Application',
    modifiedAt: '06-17-2022',
  },
];

const Documents = () => {
  const { isMobile } = useContext(ApplicationUIContext);
  const [, uploadDocument] = useDrawerState(false);

  const onUploadDocument = () => {
    uploadDocument.close();
  };

  return (
    <Space direction="vertical" size="middle">
      <CardSectionTitle>
        {getTranslatedString(
          'landlordPortal.applicationManagement.applicationOverview.applicants.documents'
        )}
      </CardSectionTitle>
      {!featureEnabled('4-0-phase-2-wip') && (
        <Table
          dataSource={DUMMY_DATA}
          columns={COLUMNS}
          hideActionAndSearch
          size={isMobile ? 'middle' : 'small'}
          scroll={{
            x: isMobile,
          }}
          pagination={{ hideOnSinglePage: true }}
        />
      )}
      <Button
        size={isMobile && 'large'}
        icon={<UploadOutlined />}
        onClick={() => {
          phaseTwoWip(uploadDocument.open);
        }}
      >
        {getTranslatedString(
          'landlordPortal.applicationManagement.applicationOverview.applicants.documents.uploadDocument'
        )}
      </Button>
      <Drawer
        title={getTranslatedString(
          'landlordPortal.applicationManagement.applicationOverview.applicants.documents.drawerTitle'
        )}
        visible={uploadDocument.isVisible}
        closable
        destroyOnClose
        onClose={uploadDocument.close}
      >
        <UploadDocument onSubmit={onUploadDocument} onCancel={uploadDocument.close} />
      </Drawer>
    </Space>
  );
};

export default Documents;
